// ! ------------------------------------------
// ! Cambiar formato
// ! ------------------------------------------
import { combineReducers } from 'redux';
import { layoutReducer } from './LayoutReducer';

// * ------------------------------------------
// * Nuevo formato
// * ------------------------------------------
import { accesosReducer } from '../modules/accesos/AccesosReducer';
import { apiKeysReducer } from '../modules/apikeys/ApiKeysReducer';
import { areasReducer } from '../modules/areas/AreasReducer';
import { loginReducer } from '../modules/auth/login/LoginReducer';
import { bancosReducer } from '../modules/bancos/BancosReducer';
import { clasesReducer } from '../modules/clases/clases/ClasesReducer';
import { clasesDocentesReducer } from '../modules/clases/clases_docentes/ClasesDocentesReducer';
import { CuposClasesReducer } from '../modules/clases/cupos/CuposClasesReducer';
import { docentesReducer } from '../modules/clases/docentes/DocentesReducer';
import { reservacionesClasesReducer } from '../modules/clases/reservaciones/ReservacionesClasesReducer';
import { tiposClasesReducer } from '../modules/clases/tipos/TiposClasesReducer';
import { tiposNivelClasesReducer } from '../modules/clases/tipos_nivel/TiposNivelClasesReducer';
import { codigosReducer } from '../modules/codigos/CodigosReducer';
import { contactosReducer } from '../modules/contactos/contactos/ContactosReducer';
import { tiposContactosReducer } from '../modules/contactos/tipos/TiposContactosReducer';
import { usersDeleteReducer } from '../modules/crm/delete_users/UsersDeleteReducer';
import { dashboardReducer } from '../modules/dashboard/DashboardReducer';
import { deliveryReducer } from '../modules/delivery/DeliveryReducer';
import { descuentosReducer } from '../modules/descuentos/descuentos/DescuentosReducer';
import { documentosReducer } from '../modules/documentos/documentos/DocumentosReducer';
import { tiposDocumentosReducer } from '../modules/documentos/tipos/TiposDocumentosReducer';
import { entDestacadasReducer } from '../modules/ent_destacadas/EntDestacadasReducer';
import { entidadBancosReducer } from '../modules/entidad_bancos/EntidadBancosReducer';
import { entidadesReducer } from '../modules/entidades/EntidadesReducer';
import { eventosReducer } from '../modules/eventos/eventos/EventosReducer';
import { tiposEventosReducer } from '../modules/eventos/tipos/TiposEventosReducer';
import { tiposImagenClasesReducer } from '../modules/eventos/tipos_imagen/TiposImagenClasesReducer';
import { invitadosReducer } from '../modules/invitados/InvitadosReducer';
import { iotTunelesReducer } from '../modules/iot_tuneles/IotTunelesReducer';
import { iotsReducer } from '../modules/iots/IotsReducer';
import { metodosPagoReducer } from '../modules/metodos_pago/MetodosPagoReducer';
import { modulosReducer } from '../modules/modulos/ModulosReducer';
import { morosidadReducer } from '../modules/morosidad/MorosidadReducer';
import { notificacionesReducer } from '../modules/notificaciones/notificaciones/NotificacionesReducer';
import { preciosCustomReducer } from '../modules/preciosCustom/PreciosCustomReducer';
import { puertasReducer } from '../modules/puertas/PuertasReducer';
import { recibosReducer } from '../modules/recibos/RecibosReducer';
import { referidosReducer } from '../modules/referidos/ReferidosReducer';
import { reservasReducer } from '../modules/reservas/ReservasReducer';
import { reservasEspecialesReducer } from '../modules/reservasEspeciales/ReservasEspecialesReducer';
import { reservasRestauranteReducer } from '../modules/restaurantes/reservas_restaurante/ReservasRestauranteReducer';
import { restaurantesReducer } from '../modules/restaurantes/restaurantes/RestaurantesReducer';
import { tiposRestauranteReducer } from '../modules/restaurantes/tipos/TiposRestauranteReducer';
import { zonasRestauranteReducer } from '../modules/restaurantes/zonas/ZonasRestauranteReducer';
import { serviciosReducer } from '../modules/servicios/servicios/ServiciosReducer';
import { tiposServiciosReducer } from '../modules/servicios/tipos/TiposServiciosReducer';
import { settingsReducer } from '../modules/settings/SettingsReducer';
import { subareasReducer } from '../modules/subareas/SubAreasReducer';
import { tiposAreasReducer } from '../modules/tipos_areas/TiposAreasReducer';
import { tiposInvitacionReducer } from '../modules/tipos_invitacion/TiposInvitacionReducer';
import { tiposNivelCodeReducer } from '../modules/tipos_niveles_code/TiposNivelCodeReducer';
import { tiposUsuariosReducer } from '../modules/tipos_usuarios/TiposUsuariosReducer';
import { citiesReducer } from '../modules/ubicacion/cities/CitiesReducer';
import { countriesReducer } from '../modules/ubicacion/countries/CountriesReducer';
import { statesReducer } from '../modules/ubicacion/states/StatesReducer';
import { usuariosReducer } from '../modules/usuarios/UsuariosReducer';

const rootReducer = combineReducers({
  restaurantes: restaurantesReducer,
  tiposNivelCode: tiposNivelCodeReducer,
  tiposRestaurante: tiposRestauranteReducer,
  accesos: accesosReducer,
  areas: areasReducer,
  servicios: serviciosReducer,
  tiposServicios: tiposServiciosReducer,
  bancos: bancosReducer,
  clases: clasesReducer,
  docentes: docentesReducer,
  clasesDocentes: clasesDocentesReducer,
  codigos: codigosReducer,
  contactos: contactosReducer,
  cuposClases: CuposClasesReducer,
  dashboard: dashboardReducer,
  delivery: deliveryReducer,
  documentos: documentosReducer,
  entidades: entidadesReducer,
  entidadBancos: entidadBancosReducer,
  entDestacadas: entDestacadasReducer,
  eventos: eventosReducer,
  invitados: invitadosReducer,
  iots: iotsReducer,
  iotTuneles: iotTunelesReducer,
  layout: layoutReducer,
  login: loginReducer,
  modulos: modulosReducer,
  puertas: puertasReducer,
  recibos: recibosReducer,
  reservas: reservasReducer,
  reservacionesClases: reservacionesClasesReducer,
  reservasEspeciales: reservasEspecialesReducer,
  zonasRestaurante: zonasRestauranteReducer,
  settings: settingsReducer,
  subareas: subareasReducer,
  tiposAreas: tiposAreasReducer,
  tiposClases: tiposClasesReducer,
  tiposNivelClases: tiposNivelClasesReducer,
  tiposContactos: tiposContactosReducer,
  tiposDocumentos: tiposDocumentosReducer,
  tiposInvitacion: tiposInvitacionReducer,
  tiposEventos: tiposEventosReducer,
  tiposImagenClases: tiposImagenClasesReducer,
  usuarios: usuariosReducer,
  metodosPago: metodosPagoReducer,
  notificaciones: notificacionesReducer,
  usersDelete: usersDeleteReducer,
  descuentos: descuentosReducer,
  referidos: referidosReducer,
  reservasRestaurante: reservasRestauranteReducer,
  preciosCustom: preciosCustomReducer,
  morosidad: morosidadReducer,
  apiKeys: apiKeysReducer,
  tiposUsuarios: tiposUsuariosReducer,

  // * Ubicación
  countries: countriesReducer,
  states: statesReducer,
  cities: citiesReducer,
});

export default rootReducer;
